import React, { useState, useEffect } from 'react';

export default function EditAdModal({ open, ad, onClose, onSave }:{ open:boolean, ad:any, onClose:()=>void, onSave:(a:any)=>void }){
  const [draft, setDraft] = useState<any>(ad || {});
  useEffect(()=>{ setDraft(ad || {
    targetAudience: { ageRange: [], gender: [], location: [], jobTitles: [] },
    schedule: { startDate: new Date().toISOString().split('T')[0], endDate: new Date(Date.now() + 30*24*60*60*1000).toISOString().split('T')[0], startTime: '09:00', endTime: '18:00', timezone: 'UTC' },
    isActive: true,
    clicks: 0,
    redirects: 0,
    analytics: { views: 0, clicks: 0, impressions: 0, ctr: '0.0' }
  } ); }, [ad]);
  if (!open) return null;
  const uploadImage = async (file: File) => {
    try {
      const form = new FormData();
      form.append('image', file);
      const token = localStorage.getItem('dev_admin_token') || '';
      const res = await fetch('/api/admin/uploads/image', { method: 'POST', body: form, headers: token ? { Authorization: `Bearer ${token}` } : undefined as any, credentials: 'include' });
      if (!res.ok) throw new Error('Upload failed');
      const j = await res.json();
      return j.url as string;
    } catch (e) {
      console.warn('Image upload failed', e);
      return null;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg w-full max-w-2xl p-4">
        <h3 className="text-lg font-semibold mb-2">Edit Advertisement</h3>
        <div className="space-y-2">
          <input value={draft.title||''} onChange={e=>setDraft({...draft, title: e.target.value})} className="w-full p-2 border rounded" placeholder="Title" />
          <input value={draft.link||''} onChange={e=>setDraft({...draft, link: e.target.value})} className="w-full p-2 border rounded" placeholder="Link URL" />
          <input value={draft.price||''} onChange={e=>setDraft({...draft, price: e.target.value})} className="w-full p-2 border rounded" placeholder="Price (e.g. $10)" />
          <textarea value={draft.description||''} onChange={e=>setDraft({...draft, description: e.target.value})} className="w-full p-2 border rounded" placeholder="Description" />

          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="block text-sm font-medium">Start Date</label>
              <input type="date" value={draft.schedule?.startDate||''} onChange={e=>setDraft({...draft, schedule: {...draft.schedule, startDate: e.target.value}})} className="w-full p-2 border rounded" />
            </div>
            <div>
              <label className="block text-sm font-medium">End Date</label>
              <input type="date" value={draft.schedule?.endDate||''} onChange={e=>setDraft({...draft, schedule: {...draft.schedule, endDate: e.target.value}})} className="w-full p-2 border rounded" />
            </div>
            <div>
              <label className="block text-sm font-medium">Start Time</label>
              <input type="time" value={draft.schedule?.startTime||'09:00'} onChange={e=>setDraft({...draft, schedule: {...draft.schedule, startTime: e.target.value}})} className="w-full p-2 border rounded" />
            </div>
            <div>
              <label className="block text-sm font-medium">End Time</label>
              <input type="time" value={draft.schedule?.endTime||'18:00'} onChange={e=>setDraft({...draft, schedule: {...draft.schedule, endTime: e.target.value}})} className="w-full p-2 border rounded" />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium">Image</label>
            <input type="file" accept="image/*" onChange={async (e)=>{ const file = e.target.files?.[0]; if (!file) return; const temp = URL.createObjectURL(file); setDraft({...draft, image: temp}); const uploaded = await uploadImage(file); if (uploaded) setDraft({...draft, image: uploaded}); try { URL.revokeObjectURL(temp); } catch {} }} className="w-full" />
            {draft.image && <img src={draft.image} alt="preview" className="w-24 h-24 object-cover rounded mt-2" />}
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="block text-sm font-medium">Target Ages (comma separated)</label>
              <input value={(draft.targetAudience?.ageRange||[]).join(', ')} onChange={e=>setDraft({...draft, targetAudience: {...draft.targetAudience, ageRange: e.target.value.split(',').map((s:string)=>s.trim())}})} className="w-full p-2 border rounded" />
            </div>
            <div>
              <label className="block text-sm font-medium">Genders (comma separated)</label>
              <input value={(draft.targetAudience?.gender||[]).join(', ')} onChange={e=>setDraft({...draft, targetAudience: {...draft.targetAudience, gender: e.target.value.split(',').map((s:string)=>s.trim())}})} className="w-full p-2 border rounded" />
            </div>
          </div>

          <div className="flex items-center gap-2">
            <label className="inline-flex items-center gap-2"><input type="checkbox" checked={!!draft.isActive} onChange={e=>setDraft({...draft, isActive: e.target.checked})} /> Active</label>
          </div>
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button onClick={onClose} className="px-3 py-1 border rounded">Cancel</button>
          <button onClick={()=>{ onSave(draft); onClose(); }} className="px-3 py-1 bg-blue-600 text-white rounded">Save</button>
        </div>
      </div>
    </div>
  );
}
